import { render, staticRenderFns } from "./Biker.vue?vue&type=template&id=247093b8&scoped=true&"
import script from "./Biker.vue?vue&type=script&lang=js&"
export * from "./Biker.vue?vue&type=script&lang=js&"
import style0 from "./Biker.vue?vue&type=style&index=0&id=247093b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247093b8",
  null
  
)

export default component.exports